// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Skeltons from "../../../components/loading/Skeltons";
import { Currency, Top } from "../purchase-requisition/configuration";
import DatePicker from "react-datepicker";
import { getObjectIdsByPRListID } from "../../../components/tools/PCGetter";


// Rumus total per supplier — SAMA dengan form Price Comparison (calculateSupplierTotal di
// insert-price-comparasion.js): diskon per item (persen, atau Rupiah) → diskon global →
// PPN + PBBKB − PPH dari total setelah diskon → + Biaya Lain-lain (di luar pajak).
// Rumus lama halaman ini MENAMBAHKAN PPH dan mengabaikan diskon per item.
const hitungSupplierKirim = (s) => {
  const items = s.PRListComparison || [];
  let subtotal = 0;
  let diskonItem = 0;
  items.forEach((it) => {
    const th = (parseFloat(it.Harga) || 0) * (parseFloat(it.Qty) || 0);
    it.TotalHarga = th;
    const dp = parseFloat(it.DiscountPercent) || 0;
    const dr = parseFloat(it.DiscountRupiah) || 0;
    diskonItem += dp > 0 ? (th * dp) / 100 : dr;
    subtotal += th;
  });
  const setelahItem = subtotal - diskonItem;
  const gp = parseFloat(s.DiscountPercent) || 0;
  const gr = parseFloat(s.DiscountRupiah) || 0;
  const diskonGlobal = gp > 0 ? (setelahItem * gp) / 100 : gr;
  const total2 = setelahItem - diskonGlobal;
  const ppn = (total2 * (parseFloat(s.PPN) || 0)) / 100;
  const pph = (total2 * (parseFloat(s.PPH) || 0)) / 100;
  const pbbkb = (total2 * (parseFloat(s.PBBKB) || 0)) / 100;
  const biayaLain = Math.max(0, parseFloat(s.BiayaLain) || 0);
  return {
    ...s,
    Total: subtotal,
    Discound: diskonItem + diskonGlobal,
    Total2: total2,
    PPNTotal: ppn,
    PPHTotal: pph,
    PBBKBTotal: pbbkb,
    BiayaLain: biayaLain,
    GTOTAL: total2 + ppn + pbbkb - pph + biayaLain,
  };
};

const KirimPriceComparisonPage = ({}) => {
  let initialState = {
    SupplierCount: 0,
    BisnisUnitID: "U0002",
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const { values, touched, customHandler, changeHandler, errors, editHandler } =
    useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [prData, setPRData] = useState([]);
  const [barang, setBarang] = useState([]);
  const [pRListComparison, setPRListComparison] = useState([]);
  const [showDetail, setshowDetail] = useState(true);
  const [generalTotal, setGeneralTotal] = useState(0);
  const [isJasa, setisJasa] = useState(false);
  const [Termin1, setTermin1] = useState("");
  const [Termin2, setTermin2] = useState("");
  const [Termin3, setTermin3] = useState("");

  const barangDetail = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [supplierSelected, setSupplierSelected] = useState(1);

  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/send", formData)
  );
  const PurchaseRequisition = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition/min", formData)
  );
  const PurchaseRequisitionDetail = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisitionStockOnly/" + formData)
  );
  const priceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonFromPRID/" + formData)
  );
  const franco = useMutation((formData) => fetchGet("Master/Franco/min"));
  const PriceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparison/" + formData)
  );
  const param = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    barangDetail.mutate();
    PurchaseRequisition.mutate({ BisnisUnitID: "U" });
    franco.mutate();
    if (param.state) {
      PriceComparison.mutate(param.state.PRComparisonID);
    }
  }, []);

  useEffect(() => {
    const index = prData.findIndex(
      (x) => x.PurchaseRequisitionID === param.state.PurchaseRequisitionID
    );

    customHandler(index, "PurchaseRequisitionID");
    PurchaseRequisitionDetail.mutate(param.state.PurchaseRequisitionID.replaceAll("/", "-"));
  }, [prData]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate("/procurment/transaksi/price-comparison");
      }
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (PurchaseRequisitionDetail.data) {
      setisJasa(
        PurchaseRequisitionDetail.data.data.Tipe == "Jasa" ? true : false
      );
      setTermin1(PurchaseRequisitionDetail.data.data.Termin1);
      setTermin2(PurchaseRequisitionDetail.data.data.Termin2);
      setTermin3(PurchaseRequisitionDetail.data.data.Termin3);
      setBarang(PurchaseRequisitionDetail.data.data.PRList);
    }
  }, [PurchaseRequisitionDetail.data]);

  useEffect(() => {
    if (PriceComparison.data) {
      const tempArray = PriceComparison.data.data;
      if (tempArray && tempArray[0]["PurchaseRequisitionID"]) {
        customHandler(tempArray.length, "SupplierCount");
        for (let selected = 0; selected < tempArray.length; selected++) {
          if (tempArray[selected]["PRListComparison"])
            for (
              let i = 0;
              i < tempArray[selected]["PRListComparison"].length;
              i++
            ) {
              const matchingObjectIds = getObjectIdsByPRListID(
                PurchaseRequisitionDetail.data.data.PRList,
                tempArray[selected]["PRListComparison"][i]["PRListID"]
              );
              tempArray[selected]["PRListComparison"][i] = {
                ...tempArray[selected]["PRListComparison"][i],
                ...matchingObjectIds[0],
              };

            }

        }
        // Hitung total tiap supplier dgn rumus yang sama dgn form PC, lalu total
        // keseluruhan (dulu setGeneralTotal dipanggil di dalam loop dgn state basi →
        // hanya supplier terakhir yang terhitung).
        let totalSemua = 0;
        for (let k = 0; k < tempArray.length; k++) {
          tempArray[k] = hitungSupplierKirim(tempArray[k]);
          totalSemua += tempArray[k].GTOTAL || 0;
        }
        setGeneralTotal(totalSemua);
        setPRListComparison(tempArray);
      }
    }
  }, [barang]);

  useEffect(() => {
    var tempArray = [];
    if (PurchaseRequisition.data) {
      if (PurchaseRequisition.data.data) {
        PurchaseRequisition.data.data.map((datas, i) => {
          tempArray.push({
            ...datas,
            value: i,
            label: datas.PurchaseRequisitionID,
          });
        });
      }
    }
    setPRData(tempArray);
  }, [PurchaseRequisition.data]);

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Qty", key: "Qty", modifiers: "number" },
    { name: "SDT Date", key: "SDTDate", modifiers: "dateOnlyNew" },
    { name: "Specification", key: "Specification", modifiers: "Text" },
  ];

  const PRHandler = (value, names) => {
    customHandler(value, names);
    PurchaseRequisitionDetail.mutate(prData[value]["PurchaseRequisitionID"].replaceAll("/", "-"));
  };

  const SupplierCount = (e) => {
    changeHandler(e);
    let detailArray = [];
    if (PurchaseRequisitionDetail.data) {
      PurchaseRequisitionDetail.data.data.PRList.map((detail, i) => {
        detailArray.push({
          ...detail,
          Harga: 0,
          DiscountPercent: 0,
          DiscountRupiah: 0,
          Merk: "",
          PilihanBeli: false,
        });
      });
    }
    if (e.target.value && e.target.value > 0) {
      let TempArray = [];
      for (let i = 1; i <= e.target.value; i++) {
        const obj = {
          TanggalKirim: new Date(),
          PPN: 0,
          PPH: 0,
          PBBKB: 0,
          PRListComparison: detailArray,
        };
        TempArray.push(obj);
      }
      if (PurchaseRequisitionDetail.data) {
        setPRListComparison(TempArray);
      }
    }
  };

  const PurchaseRequisitionDetailEditor = (ids, i, e, len) => {
    let tempArray = JSON.parse(JSON.stringify(pRListComparison));
    const selected = ids;
    let valuesTarget = e.target.value;
    if (e.target.name === "PilihanBeli") {
      valuesTarget = e.target.checked;
    }

    tempArray[selected]["PRListComparison"][i][e.target.name] = valuesTarget;
    tempArray[selected] = hitungSupplierKirim(tempArray[selected]);
    setGeneralTotal(tempArray.reduce((t, sp) => t + (sp.GTOTAL || 0), 0));

    setPRListComparison([...tempArray]);
  };

  const SupplierBuilder = () => {
    let returnArray = [];
    if (values.SupplierCount && values.SupplierCount > 0) {
      for (let i = 1; i <= values.SupplierCount; i++) {
        returnArray.push(
          <li key={i} className="mr-2" role="presentation">
            <button
              onClick={() => {
                setSupplierSelected(i);
              }}
              className={
                supplierSelected === i
                  ? "inline-block p-4 rounded-t-lg border-b-2 text-main-100 border-main-100 bg-gray-200"
                  : "inline-block p-4 rounded-t-lg border-b-2 "
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              Supplier - {i}
            </button>
          </li>
        );
      }
    }
    return returnArray;
  };

  const Kirim = () => {
    const kirim = {
      PurchaseRequisitionID: param.state.PRComparisonID,
      Total: parseInt(generalTotal),
    };

    mutationAdd.mutate(kirim);
  };

  function prEditor(name, ids, e) {
    var temp = pRListComparison;
    temp[ids][name] = e;
    setPRListComparison([...temp]);
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">

                {/* Toolbar */}
                <div className="flex w-full justify-end flex-wrap gap-2 px-3 pb-3">
                  <button
                    onClick={() => navigate("/procurment/transaksi/price-comparison")}
                    className="flex flex-row items-center justify-center bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl mr-1" />
                    Kembali
                  </button>
                  <button
                    onClick={() => Kirim()}
                    className="flex flex-row items-center justify-center bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg aria-hidden="true" role="status" className="inline mr-2 w-4 h-4 animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                        </svg>
                        Loading
                      </>
                    ) : "Kirim"}
                  </button>
                </div>

                {/* PR Info */}
                {PurchaseRequisition.data ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 px-3 mb-4">
                    <div>
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                        No. PR
                      </label>
                      <Select
                        value={prData.filter(({ value }) => value === values["PurchaseRequisitionID"])}
                        isDisabled={true}
                        name={"PurchaseRequisitionID"}
                        className={
                          (touched["PurchaseRequisitionID"] || buttonTouched) && errors["PurchaseRequisitionID"]
                            ? "appearance-none block w-full text-gray-700 border border-red-500 outline-none bg-white"
                            : "appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white border-gray-500"
                        }
                        onChange={(text) => PRHandler(text.value, "PurchaseRequisitionID")}
                        options={prData}
                      />
                    </div>
                    {prData[values["PurchaseRequisitionID"]] && (
                      <div>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Tanggal
                        </label>
                        <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500">
                          {new Date(prData[values["PurchaseRequisitionID"]]["DatePR"]).toISOString().substring(0, 10)}
                        </div>
                      </div>
                    )}
                    {prData[values["PurchaseRequisitionID"]] && (
                      <div className="sm:col-span-2 lg:col-span-1">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          Remarks
                        </label>
                        <div className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500">
                          {prData[values["PurchaseRequisitionID"]]["Remarks"]}
                        </div>
                      </div>
                    )}
                    {isJasa && Termin1 > 0 && (
                      <div>
                        <HrdInputGenerator type={"Termin"} value={Termin1} name={"Termin1"} title={"Termin 1 (%)"} onChange={changeHandler} touched={touched} buttonTouched={buttonTouched} size={"full"} required={false} errors={errors} disabled={true} priceComparison={priceComparison} isApproval={values.Termin1 <= 0 ? false : true} checked={true} showNominal={false} />
                      </div>
                    )}
                    {isJasa && Termin2 > 0 && (
                      <div>
                        <HrdInputGenerator type={"Termin"} value={Termin2} name={"Termin2"} title={"Termin 2 (%)"} onChange={changeHandler} touched={touched} buttonTouched={buttonTouched} size={"full"} required={false} errors={errors} disabled={true} priceComparison={priceComparison} isApproval={values.Termin2 <= 0 ? false : true} checked={true} showNominal={false} />
                      </div>
                    )}
                    {isJasa && Termin3 > 0 && (
                      <div>
                        <HrdInputGenerator type={"Termin"} value={Termin3} name={""} title={"Termin 3 (%)"} onChange={changeHandler} touched={touched} buttonTouched={buttonTouched} size={"full"} required={false} errors={errors} disabled={true} priceComparison={priceComparison} isApproval={values.Termin3 <= 0 ? false : true} checked={true} showNominal={false} />
                      </div>
                    )}
                  </div>
                ) : (
                  <button className="w-full sm:w-1/2 lg:w-1/3 px-3 mb-5 bg-main-100 p-2">
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline mr-3 w-4 h-4 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                    Loading
                  </button>
                )}

                {/* Jumlah Supplier */}
                <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-3 mb-4">
                  <HrdInputGenerator
                    type={"number"}
                    value={values}
                    name={"SupplierCount"}
                    title={"Jumlah Supplier"}
                    onChange={SupplierCount}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>

                <hr />

                {/* Tabel barang PR */}
                {PurchaseRequisitionDetail.isLoading ? (
                  <Skeltons />
                ) : (
                  <div className="overflow-x-auto w-full">
                    <DynamicTableSimple
                      data={barang}
                      header={header}
                      OnClick={ModalOpener}
                      name={"Purchase Requisition"}
                      barang={barangDetail.data}
                    />
                  </div>
                )}

                <hr className="my-5" />

                {/* Tab Supplier */}
                <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
                  <ul
                    className="flex flex-wrap gap-1 -mb-px text-sm font-medium text-center"
                    id="myTab"
                    data-tabs-toggle="#myTabContent"
                    role="tablist"
                  >
                    {<SupplierBuilder />}
                    <li key={"Show hide"} className="mr-2" role="presentation">
                      <button
                        className="inline-block p-4 rounded-t-lg border-b-2 bg-main-100 text-white"
                        onClick={() => setshowDetail(!showDetail)}
                      >
                        {showDetail ? "Hide" : "Show"} Supplier Data
                      </button>
                    </li>
                  </ul>
                  {PurchaseRequisitionDetail.isLoading ? (
                    <Skeltons />
                  ) : (
                    <>
                      {pRListComparison &&
                        pRListComparison.map((cats, ids) => {
                          if (ids === supplierSelected - 1) {
                            return (
                              <div key={"Main" + ids} className="mt-6">
                                {showDetail && (
                                  <div className="text-left">

                                    {/* Baris 1: Nama Supplier & Tanggal Kirim */}
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-3 mb-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Nama Supplier
                                        </label>
                                        <input
                                          type="text"
                                          // NamaSupplier = SupplierID (dipakai simpan); yang tampil
                                          // NamaSupplierDisplay (nama) dari backend.
                                          value={cats["NamaSupplierDisplay"] || cats["NamaSupplier"] || ""}
                                          name={"NamaSupplier"}
                                          disabled={true}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(e) => prEditor("NamaSupplier", ids, e.target.value)}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Tanggal Kirim
                                        </label>
                                        <DatePicker
                                          utcOffset={0}
                                          dateFormat="dd/MMMM/yyyy"
                                          disabled={true}
                                          selected={new Date(cats["TanggalKirim"])}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(text) => prEditor("Currency", ids, text)}
                                        />
                                      </div>
                                    </div>

                                    {/* Baris 2: Franco, TOP, Currency */}
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 px-3 mb-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Franco
                                        </label>
                                        {franco.data && (
                                          <Select
                                            value={franco.data.data.filter(({ value }) => value === cats["FrancoID"])}
                                            isDisabled={true}
                                            name={"FrancoID"}
                                            className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white"
                                            onChange={(text) => prEditor("FrancoID", ids, text.value)}
                                            options={franco.data.data}
                                          />
                                        )}
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          TOP
                                        </label>
                                        <Select
                                          value={Top.filter(({ value }) => value === cats["TOP"])}
                                          isDisabled={true}
                                          name={"TOP"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white"
                                          onChange={(text) => prEditor("TOP", ids, text.value)}
                                          options={Top}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Currency
                                        </label>
                                        <Select
                                          value={Currency.filter(({ value }) => value === cats["Currency"])}
                                          isDisabled={true}
                                          name={"Currency"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white"
                                          onChange={(text) => prEditor("Currency", ids, text.value)}
                                          options={Currency}
                                        />
                                      </div>
                                    </div>

                                    {/* Baris 3: Discount */}
                                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 px-3 mb-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Diskon %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["DiscountPercent"]}
                                          name={"DiscountPercent"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(e) => prEditor("DiscountPercent", ids, e.target.value)}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Diskon Rp
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          value={cats["DiscountRupiah"]}
                                          name={"DiscountRupiah"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(e) => prEditor("DiscountRupiah", ids, e.target.value)}
                                        />
                                      </div>
                                    </div>

                                    {/* Baris 4: PPN, PPH, PBBKB */}
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 px-3 mb-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PPN %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PPN"]}
                                          name={"PPN"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(e) => prEditor("PPN", ids, e.target.value)}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PPH %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PPH"]}
                                          name={"PPH"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(e) => prEditor("PPH", ids, e.target.value)}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PBBKB %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PBBKB"]}
                                          name={"PBBKB"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                          onChange={(e) => prEditor("PBBKB", ids, e.target.value)}
                                        />
                                      </div>
                                    </div>

                                    {/* Baris 4b: Biaya Lain-lain — di luar pajak (tak kena PPN/PPH/PBBKB) */}
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 px-3 mb-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Biaya Lain-lain
                                        </label>
                                        <input
                                          disabled={true}
                                          type="text"
                                          value={(parseFloat(cats["BiayaLain"]) || 0).toLocaleString("in-ID", { maximumFractionDigits: 0 })}
                                          name={"BiayaLain"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                        />
                                      </div>
                                      <div className="sm:col-span-2">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Keterangan Biaya Lain-lain
                                        </label>
                                        <input
                                          disabled={true}
                                          type="text"
                                          value={cats["KeteranganBiayaLain"] || "-"}
                                          name={"KeteranganBiayaLain"}
                                          className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white"
                                        />
                                      </div>
                                    </div>

                                    {/* Baris 5: TOC full width */}
                                    <div className="px-3 mb-4">
                                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Term of Condition
                                      </label>
                                      <textarea
                                        disabled={true}
                                        value={cats["TOC"]}
                                        name={"TOC"}
                                        rows={3}
                                        className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white resize-none"
                                        onChange={(e) => prEditor("TOC", ids, e.target.value)}
                                      />
                                    </div>

                                  </div>
                                )}

                                {/* Tabel item supplier */}
                                <div className="overflow-x-auto w-full mt-6">
                                <table className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 min-w-max">
                                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                    <tr>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Barang
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Harga
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center border-b"
                                        colSpan={2}
                                      >
                                        Discound
                                      </th>

                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Merk
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Total Harga
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Pilihan Beli
                                      </th>
                                    </tr>
                                    <tr>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center"
                                      >
                                        %
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center"
                                      >
                                        Rp
                                      </th>
                                    </tr>
                                  </thead>

                                  <>
                                    {cats["PRListComparison"] &&
                                      cats["PRListComparison"].map(
                                        (detail, id) => {
                                          let classOdd =
                                            "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                                          if (id % 2 === 0)
                                            classOdd =
                                              "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                                          let texts = "";
                                          if (barangDetail.data) {
                                            const val =
                                              barangDetail.data.data.filter(
                                                ({ value }) =>
                                                  value === detail.BarangID
                                              );
                                            if (val[0]) {
                                              texts = val[0]["label"];
                                            }
                                          }
                                          return (
                                            <tr
                                              key={
                                                id + "rows" + supplierSelected
                                              }
                                              className={classOdd}
                                            >
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowt" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                {texts}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={detail["Harga"]}
                                                  name={"Harga"}
                                                  disabled={true}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumber" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={
                                                    detail["DiscountPercent"]
                                                  }
                                                  max={"100"}
                                                  disabled={true}
                                                  name={"DiscountPercent"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumbers" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  disabled={true}
                                                  value={
                                                    detail["DiscountRupiah"]
                                                  }
                                                  name={"DiscountRupiah"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowMerk" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="text"
                                                  disabled={true}
                                                  value={detail["Merk"]}
                                                  name={"Merk"}
                                                  className={
                                                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowTotalHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap text-right"
                                                }
                                              >
                                                {parseFloat(
                                                  detail["TotalHarga"]
                                                ).toLocaleString("in-ID", {
                                                  maximumFractionDigits: 2,
                                                })}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowPilihanBeli" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="checkbox"
                                                  value={true}
                                                  checked={
                                                    detail["PilihanBeli"]
                                                  }
                                                  disabled={true}
                                                  name={"PilihanBeli"}
                                                  className={
                                                    "w-4 h-4 text-main-100 bg-gray-100 rounded border-main-100"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                            </tr>
                                          );
                                        }
                                      )}
                                    <>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total 1
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Total"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Discound
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Discound"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total 2
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Total2"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PPN
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PPNTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PPH (-)
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PPHTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PBBKB
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PBBKBTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      {(parseFloat(cats["BiayaLain"]) || 0) > 0 && (
                                        <tr className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10">
                                          <th
                                            scope="row"
                                            colSpan={5}
                                            className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                          >
                                            Biaya Lain-lain
                                            {cats["KeteranganBiayaLain"] ? ` (${cats["KeteranganBiayaLain"]})` : ""}
                                          </th>
                                          <th
                                            scope="row"
                                            className="py-4 px-6 font-medium whitespace-nowrap text-right"
                                          >
                                            {(parseFloat(cats["BiayaLain"]) || 0).toLocaleString("in-ID", {
                                              maximumFractionDigits: 2,
                                            })}
                                          </th>
                                          <th scope="row" className="py-4 px-6 font-medium whitespace-nowrap "></th>
                                        </tr>
                                      )}
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["GTOTAL"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                    </>
                                  </>
                                </table>
                                </div>
                              </div>
                            );
                          }
                        })}
                    </>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KirimPriceComparisonPage;
